export default __webpack_public_path__ + "static/media/poolIMG.964a9e36.jpg";